import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import {CustomMessages} from '../components/CustomMessages';

class InvoicePragmaReturnContainer extends BaseContainer {
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    getContainerListName() {
        return 'invoice-download-container';
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div id='main-invoice-download'>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                    <div className='invoice-download-background-container'>
                        <img src='/images/login-moya-background.svg' className='login-background-moya' alt='logo moya' />
                        <div className='login-moya-logo-container' style={{marginBottom:'10px'}}>
                            <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                        </div>
                        <div className='invoice-download-text-container'>
                            <span className='invoice-pragma-welcome-text'>{t('invoicePragmaReturn.welcomeText')}</span>
                        </div>
                        <div className='invoice-download-guide-text-container'>
                            <div className='invoice-download-guide-text'>{t('invoicePragmaReturn.guideText')}</div>
                        </div>
                        <div className='invoice-download-text-container'>
                            <span className='invoice-pragma-welcome-text'>{t('invoicePragmaReturn.anwim')}</span>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

InvoicePragmaReturnContainer.propTypes = {};

export default withTranslation()(InvoicePragmaReturnContainer);
